<template lang="pug">
.confirmacao-inscricao
  .confirmacao-inscricao__painel
    a.confirmacao-inscricao__logo-link(:href="portalHomeUrl")
      img.confirmacao-inscricao__logo(
        src="@/assets/icons/cadastro/logo-sicarf-dark.svg"
        alt="SICARF"
      )

    .confirmacao-inscricao__conteudo
      img.confirmacao-inscricao__icone(
        src="@/assets/icons/cadastro/check-teal.svg"
        alt=""
        width="56"
        height="56"
      )

      h1.confirmacao-inscricao__titulo Inscrição realizada com sucesso

      p.confirmacao-inscricao__texto
        | Enviamos um e-mail para
        |
        span.confirmacao-inscricao__email {{ emailExibido }}
        |
        | com instruções para concluir o cadastro da sua conta.
        | Por favor, verifique sua caixa de entrada e clique no link para confirmar sua conta e acompanhar o processo de análise e resultado do edital.

      p.confirmacao-inscricao__ajuda
        | Não recebeu o e-mail?
        br
        | Verifique sua caixa de spam ou
        |
        button.confirmacao-inscricao__reenviar(
          type="button"
          @click="reenviarEmail"
        ) Clique aqui para reenviar o link

      a.confirmacao-inscricao__login(:href="loginUrl") Ir para a página de login

  .confirmacao-inscricao__hero(aria-hidden="true")
    img.confirmacao-inscricao__hero-img(
      src="@/assets/images/cadastro/confirmacao-hero.jpg"
      alt=""
    )
    .confirmacao-inscricao__hero-overlay
</template>

<script>
import { AppNotificacao } from 'sicarf-components'

export default {
  name: 'CadastroCredenciadoConfirmacao',
  mixins: [AppNotificacao],
  computed: {
    emailExibido () {
      return this.$route.query.email || 'seu e-mail'
    },
    portalHomeUrl () {
      return (process.env.VUE_APP_ROOT_PARAMETRIZAVEL_URL || '').replace(/\/$/, '') || '#'
    },
    loginUrl () {
      return `${process.env.VUE_APP_SICARF_URL}/#/login`
    }
  },
  methods: {
    reenviarEmail () {
      // Endpoint de reenvio ainda não existe no backend de credenciados.
      this.showNotificacao(
        this.$messages.TIPO_INFO,
        this.$messages.TITULO_WARNING,
        this.$messages.EMAIL_CONFIRMACAO_REENVIAR_INDISPONIVEL
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.confirmacao-inscricao {
  background: #ffffff;
  display: flex;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  width: 100%;
}

.confirmacao-inscricao__painel {
  display: flex;
  flex: 1 1 50%;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: clamp(24px, 4vh, 40px) clamp(24px, 4vw, 40px);
}

.confirmacao-inscricao__logo-link {
  display: inline-flex;
  flex-shrink: 0;
  height: 32px;
  width: 110px;
}

.confirmacao-inscricao__logo {
  display: block;
  height: 100%;
  object-fit: contain;
  width: 100%;
}

.confirmacao-inscricao__conteudo {
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  gap: clamp(16px, 3vh, 24px);
  justify-content: center;
  margin: auto;
  max-width: min(400px, 100%);
  padding: clamp(16px, 3vh, 32px) 0;
  text-align: center;
  width: 100%;
}

.confirmacao-inscricao__icone {
  display: block;
  flex-shrink: 0;
  height: 56px;
  width: 56px;
}

.confirmacao-inscricao__titulo {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: clamp(20px, 2.5vw, 24px);
  font-weight: 600;
  line-height: normal;
  margin: 0;
}

.confirmacao-inscricao__texto {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
  width: 100%;
}

.confirmacao-inscricao__email {
  color: #18c5c2;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.confirmacao-inscricao__ajuda {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  max-width: min(298px, 100%);
}

.confirmacao-inscricao__reenviar {
  background: transparent;
  border: 0;
  color: #18c5c2;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.9;
  }
}

.confirmacao-inscricao__login {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  color: #141414;
  display: inline-flex;
  flex-shrink: 0;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  justify-content: center;
  line-height: 1.43;
  padding: 0 16px;
  text-decoration: none;
  transition: opacity 0.2s;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
}

.confirmacao-inscricao__hero {
  flex: 1 1 50%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.confirmacao-inscricao__hero-img {
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  width: 100%;
}

.confirmacao-inscricao__hero-overlay {
  background-image:
    linear-gradient(-65.77deg, rgba(0, 187, 186, 0) 61.4%, rgb(0, 187, 186) 163%),
    linear-gradient(105.02deg, rgba(0, 47, 29, 0) 40.18%, rgb(0, 0, 36) 135.63%);
  inset: 0;
  pointer-events: none;
  position: absolute;
}

@media (max-width: 900px) {
  .confirmacao-inscricao {
    flex-direction: column;
  }

  .confirmacao-inscricao__painel {
    flex: 1 1 auto;
  }

  .confirmacao-inscricao__hero {
    display: none;
  }
}
</style>
